import { useContext, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { usePublicTransportService } from "../../../../hooks";
import ImportTable from "../ImportTable/ImportTable";
import ComparisonReport from "./ComparisonReport";
import DownloadTable from "./DownloadTable";
import TriggerImport from "./ImportActions";
import SnapshotTable from "./SnapshotTable";
import { LayerContext } from "../LayerContext";

const CardButton = styled(Card).attrs({ className: "text-black bg-light" })`
  height: 3rem;
  vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: #c1efd2 !important;
  }
`;

const PublicTransportLayer = () => {
  const navigate = useNavigate();
  const publicTransportService = usePublicTransportService();
  const layerContext = useContext(LayerContext);

  const { layerTab, layerName } = useParams();

  const [loadingInProgressDownloads, setLoadingInProgressDownloads] =
    useState(true);
  const [hasInProgressDownloads, setHasInProgressDownloads] = useState(false);

  useEffect(() => {

    publicTransportService
      .GetCurrentQuarterInProgressDownloads()
      .then((data) => {
        setLoadingInProgressDownloads(false);
        setHasInProgressDownloads(data.length > 0);
      });
  }, [layerTab]);

  const renderTab = (layerTab?: string) => {
    switch (layerTab) {
      case "imports":
        return (
          <>
            <TriggerImport
              service={publicTransportService}
              loadingDownloads={loadingInProgressDownloads}
              hasDownloadsOutstanding={hasInProgressDownloads}
              onSubmitted={() => {
                layerContext?.refreshLayerInfo();
              }}
            />
            <ImportTable />
          </>
        );
      case "snapshots":
        return (
          <SnapshotTable publicTransportService={publicTransportService} />
        );
      case "quarter-comparison":
        return <ComparisonReport service={publicTransportService} />;
      case "downloads":
        return <DownloadTable />;
      default:
        return (
          <Row className="mt-5 justify-content-center">
            <Col className="col-md-4">
              <CardButton
                onClick={() => navigate(`/admin/layers/${layerName}/imports`)}
                className="bg-light text-center mb-3"
              >
                Imports
              </CardButton>
              <CardButton
                onClick={() => navigate(`/admin/layers/${layerName}/snapshots`)}
                className="bg-light text-center mb-3"
              >
                Snapshots
              </CardButton>
              <CardButton
                onClick={() => navigate(`/admin/layers/${layerName}/downloads`)}
                className="bg-light text-center mb-3"
              >
                Downloads
              </CardButton>
              <CardButton
                onClick={() =>
                  navigate(`/admin/layers/${layerName}/quarter-comparison`)
                }
                className="bg-light text-center mb-3"
              >
                Quarter Reports
              </CardButton>
            </Col>
          </Row>
        );
    }
  };

  return (
    <>
      <>{renderTab(layerTab)}</>
    </>
  );
};

export default PublicTransportLayer;
